import React, { Component } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import classNames from "classnames";
import { bool, string, func, number } from "prop-types";

import { actions as loginActions, selectors as loginSelectors } from "reducers/login";
import { selectors as i18nSelectors } from "reducers/i18n";
import { actions as sessionActions, selectors as sessionSelectors } from "reducers/session";

import Notification from "pages/_components/Notification";
import Step3Content from "pages/login/_components/Step3Content";
import MainContainer from "pages/_components/MainContainer";
import withExchangeToken from "pages/_components/withExchangeToken";
import { push } from "connected-react-router";
import Head from "pages/_components/Head";
import LogoTitle from "./_components/LogoTitle";

class LoginStep3 extends Component {
    componentDidMount() {
        const { dispatch, activeEnvironment, username } = this.props;
        if (activeEnvironment) {
            dispatch(push("/desktop"));
        } else if (!username) {
            dispatch(push("/"));
        }
    }

    onHeaderBack = () => {
        const { dispatch } = this.props;
        dispatch(sessionActions.logout());
        dispatch(loginActions.reset());
        dispatch(push("/"));
    };

    render() {
        const { isDesktop } = this.props;

        return (
            <>
                <Notification scopeToShow="loginStep3" />
                {!isDesktop ? (
                    <>
                        <Head
                            title="login.step3.title"
                            styleOther={{ backgroundColor: "transparent", boxShadow: "none" }}
                            onBack={this.onHeaderBack}
                            hideNavbarInMobile
                        />

                        <LogoTitle />
                    </>
                ) : (
                    <Head
                        title=""
                        styleOther={{ backgroundColor: "transparent", boxShadow: "none" }}
                        onBack={this.onHeaderBack}
                        hideNavbarInMobile
                    />
                )}
                <MainContainer className={classNames({ "container-fluid": isDesktop })}>
                    <Step3Content {...this.props} />
                </MainContainer>
            </>
        );
    }
}

LoginStep3.propTypes = {
    isDesktop: bool.isRequired,
    userFirstName: string.isRequired,
    dispatch: func.isRequired,
    username: string.isRequired,
    activeEnvironment: number,
    isFetchingLang: bool.isRequired,
};

LoginStep3.defaultProps = {
    activeEnvironment: null,
};

const mapStateToProps = (state) => ({
    userFirstName: loginSelectors.getUserFirstName(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
    username: loginSelectors.getUsername(state),
    isFetchingLang: i18nSelectors.getFetching(state),
});

export default compose(withRouter, connect(mapStateToProps))(withExchangeToken(LoginStep3));
